
import { irctcAccountUserNameAPI } from '@mmt/rails/src/Utils/RailsConstant';
import { RAILS_IRCTC_USERNAME } from 'apps/rails/src/Utils/RailsConstant';
import { Platform } from 'react-native';
export const ACTION_UPDATE_USERNAME = '@rails/ACTION_UPDATE_USERNAME';
export const ACTION_UPDATE_VERIFICATION_FLOW = '@rails/ACTION_UPDATE_VERIFICATION_FLOW';
export const ACTION_UPDATE_AADHAR_FLOW = '@rails/ACTION_UPDATE_AADHAR_FLOW';

import { setItemIntoSession } from 'apps/rails/src/Utils/MMTUIWebUtils'

export const updateUsername = irctcUserName => async (dispatch) => {

  dispatch({
    type: ACTION_UPDATE_USERNAME,
    data: {
      irctcUserName
    }
  });
  //TODO: remove this PII data usage
  if (Platform.OS === 'web'){
    await setItemIntoSession(
      RAILS_IRCTC_USERNAME,
      irctcUserName
    );
  }
};

export const validateUsernameField = (text) => {
  const regex = /^[a-zA-Z0-9_]*$/;
  return regex.test(text);
};

export const updateVerificationFlow = (verificationFlow = {}) => async (dispatch) => {
  dispatch({
    type: ACTION_UPDATE_VERIFICATION_FLOW,
    data: {
      verificationFlow
    }
  });
};

export const initUserFlowDetails = () => async (dispatch) => {
  const irctcUserName = await irctcAccountUserNameAPI();
  dispatch(updateUsername(irctcUserName));
};

export const updateConfigKeyResponseForAadharVerification = (response) => async (dispatch) => {
  dispatch({
    type: ACTION_UPDATE_AADHAR_FLOW,
    data: {
      aadharConfigKeyResponse: response,
    },
  });
};